import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $empty?: boolean; $url?: boolean }>`
	position: relative;
	width: 72px;
	height: 72px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 5px;
	background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='rgba(255, 255, 255, 0.25)' stroke-width='1' stroke-dasharray='10%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
	transition: background-color 0.3s ease;
	cursor: pointer;
	overflow: hidden;

	.img-icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(
			-50%,
			${(props) => (props.$empty ? '-50%' : 'calc(-50% - 12px)')}
		);
		opacity: ${(props) => (props.$empty ? 0.5 : 1)};
		background-color: #ffffff;
		transition:
			opacity 0.3s ease,
			background-color 0.3s ease;
	}

	${(props) =>
		props.$empty &&
		css`
			&:hover {
				background-color: #ffffff;

				.img-icon {
					opacity: 1;
					background-color: #000000;
				}
			}
		`}

	${(props) =>
		!props.$empty &&
		!props.$url &&
		css`
			background-color: #2d70da;

			&:hover {
				background-color: #ffffff;

				.img-icon {
					opacity: 1;
					background-color: #000000;
				}

				${StyledUrlText} {
					color: #000000;
				}
			}
		`}
`;

const StyledImage = styled.img`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 5px;
	user-select: none;
	pointer-events: none;
	user-select: none;
	border: 2px solid #2d70da;
`;

const StyledUrlText = styled(Text)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, calc(-50% + 17px));
	max-width: 64px;
	display: block;
	font-size: 12px;
	color: #ffffff;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	transition: color 0.3s ease;
`;

export { StyledContainer, StyledImage, StyledUrlText };
